// extracted by mini-css-extract-plugin
export var formContainer = "_h5-0";
export var message = "_h5-1";